module.exports = "/subscriptions/assets/5a76a27d16ac20aaf1e6b056d8fb5cb4.png";